<app-tab-button (onClick)="toggleCity()" label="{{selectedCity | uppercase}}" [icon]="faMapMarkerAlt">
</app-tab-button>

<app-city-popup [openCity]="true" *ngIf="showCityPopup"></app-city-popup>